<app-page-meta pageTitle="finzy - Payment Successful"></app-page-meta>
<app-header></app-header>

<app-payment-success-template 
    [rowOne]="rowOne" 
    [rowTwo]="rowTwo" 
    [templateButtonText]="templateButtonText"
    [isComingFromPartnerRetailer]="isComingFromPartnerRetailer"
    (buttonClickedHandler)="onClickDashboard($event)">
</app-payment-success-template>

<app-footer></app-footer>